'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPricetag = function IoIosPricetag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.3 10c0-0.9 0.3-1.2 1.2-1.2s1.3 0.3 1.3 1.2-0.4 1.3-1.3 1.3-1.2-0.4-1.2-1.3z m-3.8-7.5h12.5v12.5l-20 22.5-12.5-12.5z m5 10c0.7 0 1.3-0.3 1.7-0.8s0.8-1 0.8-1.7-0.3-1.2-0.8-1.7-1-0.8-1.7-0.8-1.2 0.3-1.7 0.8-0.8 1-0.8 1.7 0.3 1.3 0.8 1.7 1 0.8 1.7 0.8z' })
        )
    );
};

exports.default = IoIosPricetag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-pricetag.js
// module id = 2735
// module chunks = 168707334958949